import { createSlice } from '@reduxjs/toolkit';

export const colorPickerSlice = createSlice({
    name: 'colorPicker',
    initialState: {
        isColorPickerOpen: false,
        activeColorIndex: null,
        colors: ['#000000'] // Default colors array
    },
    reducers: {
        openColorPicker: (state, action) => {
            state.isColorPickerOpen = true;
            state.activeColorIndex = action.payload;
        },
        closeColorPicker: (state) => {
            state.isColorPickerOpen = false;
        },
        updateColor: (state, action) => {
            state.colors[action.payload.index] = action.payload.color;
        }
    }
});

// Export actions
export const { openColorPicker, closeColorPicker, updateColor } = colorPickerSlice.actions;

// Export reducer
export default colorPickerSlice.reducer;
